/* MYNTELO mobile flow v6.0 (2026-10-21, Michael). Danny: "mobile needs to be very easy, fluid and high converting".
   1. "Choose your model" gate (v5.9, sections/main-product.liquid): the Add to bag button is no longer `disabled` while no model
      is chosen, it carries aria-disabled="true" + data-mx-choose, so a tap answers. Here, before any other handler (window capture),
      a tap or a form submit on a gated button never adds anything: phones open the model sheet, larger screens bring the Model
      dropdown into view and focus it.
   2. Model sheet (phones, < 750px): a bottom sheet over the native Model <select>, which stays the source of truth (keyboard and
      screen-reader users keep the native control; a transparent button over it takes the taps). Suggested first (the model this
      visitor picked before, the screen-size guess), then the newest phones, then every model, with a search field.
      Picking a row sets the <select> and fires `change`, so the theme's own handlers lift the gate, set the variant, price and
      the 3D model; the pick is remembered in localStorage 'myntelo:device' like a dropdown pick (assets/myntelo-device.js).
   window.MynteloPicker.open() is used by the sticky bar (assets/myntelo-commerce.js).
   v6.2 phase 1: window.MynteloPicker.pick(models, current, onPick) opens the same sheet for a list of models that is not a
   <select> on the page (collection cards, assets/myntelo-collection.js); the pick is remembered the same way, then onPick(model).
   v6.3 round 4 (2026-10-22, Michael): pick(models, current, onPick, opts). With a pre-selected model the sheet leads with one
   primary button "Add to bag · iPhone 17 Pro" (= tapping that row) and a quieter "Buy now" (opts.onBuy: the collection adds the
   variant and goes straight to checkout); opts.facts is one muted line at the foot of the sheet. Clarity tag model_chosen. */
(function () {
  'use strict';
  var W = window, D = document, KEY = 'myntelo:device';
  var mq = W.matchMedia ? W.matchMedia('(max-width: 749px)') : { matches: false };
  var reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function tag(k, v) { try { if (typeof W.clarity === 'function') { W.clarity('set', k, String(v)); W.clarity('event', k); } } catch (e) {} }
  function kindOf(m) { return /^iPhone/i.test(m || '') ? 'iphone' : /^Samsung Galaxy/i.test(m || '') ? 'galaxy' : null; }

  /* The Model <select> of the main product form (Option select whose label says Model, 2+ real values). */
  function modelSelect(scope) {
    var list = (scope || D).querySelectorAll('#MainContent variant-selects select, #MainContent variant-radios select');
    for (var i = 0; i < list.length; i++) {
      var s = list[i], lab = D.querySelector('label[for="' + s.id + '"]');
      var name = ((lab && lab.textContent) || s.name || '').toLowerCase();
      if (name.indexOf('model') >= 0 && s.options.length > 1) return s;
    }
    return null;
  }
  function gateButton(sel) {
    var form = sel && sel.getAttribute('form') && D.getElementById(sel.getAttribute('form'));
    return form ? form.querySelector('[type="submit"]') : null;
  }

  /* ---------- sheet ---------- */
  var sheet, list, q, lastFocus, cur;
  function build() {
    if (sheet) return;
    sheet = D.createElement('div');
    sheet.className = 'mx-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="mx-sheet__bg" data-mx-close></div>' +
      '<div class="mx-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="MxSheetTitle">' +
        '<div class="mx-sheet__grab" aria-hidden="true"></div>' +
        '<div class="mx-sheet__head"><h2 class="mx-sheet__title" id="MxSheetTitle" tabindex="-1">Choose your model</h2>' +
        '<button type="button" class="mx-sheet__close" data-mx-close aria-label="Close">' +
        '<svg viewBox="0 0 18 17" width="16" height="16" aria-hidden="true" focusable="false"><path d="m1 1 16 15M17 1 1 16" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></button></div>' +
        '<div class="mx-sheet__go" hidden><button type="button" class="mx-sheet__add" data-mx-add></button>' +
        '<button type="button" class="mx-sheet__buy" data-mx-buy>Buy now</button></div>' +
        '<div class="mx-sheet__search"><label class="visually-hidden" for="MxSheetQ">Search models</label>' +
        '<input id="MxSheetQ" type="search" inputmode="search" autocomplete="off" placeholder="Search your model"></div>' +
        '<div class="mx-sheet__list" role="listbox" aria-labelledby="MxSheetTitle"></div>' +
        '<p class="mx-sheet__foot" hidden></p>' +
      '</div>';
    D.body.appendChild(sheet);
    list = sheet.querySelector('.mx-sheet__list');
    q = sheet.querySelector('input');
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet || e.target.closest('[data-mx-close]')) { close(); return; }
      if (e.target.closest('[data-mx-add]') && cur && cur.value) { choose(cur.value); return; }
      if (e.target.closest('[data-mx-buy]') && cur && cur.value) { choose(cur.value, true); return; }
      var row = e.target.closest('[data-mx-val]');
      if (row) choose(row.getAttribute('data-mx-val'));
    });
    q.addEventListener('input', function () { paint(q.value); });
    D.addEventListener('keydown', function (e) {
      if (!sheet || sheet.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var i = f.indexOf(D.activeElement), n = e.shiftKey ? (i <= 0 ? f.length - 1 : i - 1) : (i < 0 || i >= f.length - 1 ? 0 : i + 1);
      e.preventDefault(); f[n].focus();
    }, true);
    /* drag the handle down to close */
    var y0 = null, panel = sheet.querySelector('.mx-sheet__panel');
    panel.addEventListener('touchstart', function (e) { if (e.target.closest('.mx-sheet__grab, .mx-sheet__head')) y0 = e.touches[0].clientY; }, { passive: true });
    panel.addEventListener('touchmove', function (e) { if (y0 === null) return; var dy = e.touches[0].clientY - y0; if (dy > 0) panel.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
    panel.addEventListener('touchend', function (e) { if (y0 === null) return; var dy = (e.changedTouches[0].clientY - y0); y0 = null; panel.style.transform = ''; if (dy > 90) close(); }, { passive: true });
  }
  /* v6.0b: the screen-size guess that used to sit above the dropdown as chips (assets/myntelo-device.js; hidden on phones by
     assets/myntelo-mobile.css so the buy box fits the first screen) leads the sheet as "Suggested for your screen". */
  function suggested(opts) {
    var kind = kindOf(opts[0]), out = [], add = function (m) { if (m && opts.indexOf(m) >= 0 && out.indexOf(m) < 0) out.push(m); };
    try { var p = JSON.parse(localStorage.getItem(KEY) || 'null'); if (p && p.model && kindOf(p.model) === kind) add(p.model); } catch (e) {}
    try { var ph = W.MynteloDevice && W.MynteloDevice.phoneFor && W.MynteloDevice.phoneFor(kind); if (ph) (ph.cands || [ph.model]).forEach(add); } catch (e) {}
    return out.slice(0, 4);
  }
  function popular(opts, skip) {
    var kind = kindOf(opts[0]), out = [], add = function (m) { if (m && opts.indexOf(m) >= 0 && out.indexOf(m) < 0 && skip.indexOf(m) < 0) out.push(m); };
    if (kind === 'iphone') ['iPhone 18 Pro', 'iPhone 17 Pro', 'iPhone 17', 'iPhone 17 Pro Max', 'iPhone 16'].forEach(add);
    else opts.slice(0, 4).forEach(add);
    return out.slice(0, 5);
  }
  var gid = 0;
  function group(label, rows) {
    var id = 'MxSheetG' + (++gid);
    return '<div role="group" aria-labelledby="' + id + '"><p class="mx-sheet__group" id="' + id + '" role="presentation">' + esc(label) + '</p>' + rows.map(row).join('') + '</div>';
  }
  function row(m) {
    var on = cur && cur.value === m;
    return '<button type="button" class="mx-sheet__row" role="option" aria-selected="' + on + '" data-mx-val="' + esc(m) + '"><span>' + esc(m) + '</span>' + (on ? '<span class="mx-sheet__tick" aria-hidden="true">✓</span>' : '') + '</button>';
  }
  function paint(term) {
    var opts = [].filter.call(cur.options, function (o) { return o.value && !o.disabled; }).map(function (o) { return o.value; });
    var t = (term || '').trim().toLowerCase(), html = '';
    if (t) {
      var hit = opts.filter(function (m) { return m.toLowerCase().replace(/^samsung /, '').indexOf(t.replace(/^samsung /, '')) >= 0 || m.toLowerCase().indexOf(t) >= 0; });
      html = hit.length ? hit.map(row).join('') : '<p class="mx-sheet__none" role="presentation">No model matches “' + esc(term) + '”.</p>';
    } else {
      var sug = suggested(opts), pop = popular(opts, sug);
      if (sug.length) html += group('Suggested for your screen', sug);
      if (pop.length) html += group('Popular', pop);
      html += group('All models', opts);
    }
    list.innerHTML = html;
  }
  function open(sel) {
    cur = sel || modelSelect();
    if (!cur) return false;
    build();
    lastFocus = D.activeElement;
    q.value = '';
    paint('');
    /* round 4: the pre-selected model leads (collection cards only) */
    var o = cur._mxOpts || null, go = sheet.querySelector('.mx-sheet__go'), foot = sheet.querySelector('.mx-sheet__foot');
    var pre = o && cur.value;
    go.hidden = !pre;
    if (pre) sheet.querySelector('[data-mx-add]').textContent = 'Add to bag · ' + cur.value;
    sheet.querySelector('[data-mx-buy]').hidden = !(pre && typeof o.onBuy === 'function');
    foot.innerHTML = (o && o.pay ? '<span class="mx-sheet__pay" role="img" aria-label="Payment methods include Shop Pay, Apple Pay, Google Pay and PayPal">' + o.pay + '</span>' : '') +
      '<span class="mx-sheet__facts"></span>';
    foot.querySelector('.mx-sheet__facts').textContent = (o && o.facts) || '';
    foot.hidden = !(o && (o.facts || o.pay));
    sheet.hidden = false;
    D.documentElement.classList.add('mx-sheet-open');
    inertPage(true);
    void sheet.offsetWidth;
    sheet.classList.add('is-open');
    var t = sheet.querySelector('.mx-sheet__title');
    try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); }
    var on = list.querySelector('[aria-selected="true"]');
    if (on) on.scrollIntoView({ block: 'center' });
    return true;
  }
  /* the page behind the open sheet is inert (no Tab, no screen-reader browsing); restored on close */
  var inerted = [];
  function inertPage(on) {
    if (on) {
      inerted = [].filter.call(D.body.children, function (el) { return el !== sheet && !el.inert && el.tagName !== 'SCRIPT'; });
      inerted.forEach(function (el) { el.inert = true; el.setAttribute('data-mx-inert', ''); });
    } else {
      inerted.forEach(function (el) { el.inert = false; el.removeAttribute('data-mx-inert'); });
      inerted = [];
    }
  }
  function focusables() { return [].filter.call(sheet.querySelectorAll('button, input, [tabindex]:not([tabindex="-1"])'), function (el) { return !el.disabled && el.offsetParent !== null; }); }
  /* where focus goes back to: never an aria-hidden or hidden element (the tap layer over the select is aria-hidden) */
  function returnTarget() {
    var t = lastFocus;
    if (!t || !t.focus || t === D.body || t.closest('[aria-hidden="true"]') || t.offsetParent === null) t = cur;
    return t;
  }
  function close(after) {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    D.documentElement.classList.remove('mx-sheet-open');
    inertPage(false);
    setTimeout(function () { sheet.hidden = true; if (after) after(); else { var t = returnTarget(); if (t) { try { t.focus({ preventScroll: true }); } catch (e) {} } } }, reduce ? 0 : 260);
  }
  function choose(m, buy) {
    var sel = cur;
    if (!sel) return;
    if (sel._mxOnPick) {
      var pk = kindOf(m);
      if (pk) { try { localStorage.setItem(KEY, JSON.stringify({ brand: pk, model: m, t: Date.now() })); } catch (e) {} }
      try { (W.dataLayer = W.dataLayer || []).push({ event: 'myntelo_device_pick', brand: pk, model: m, how: buy ? 'sheet-card-buy' : 'sheet-card' }); } catch (e) {}
      tag('model_chosen', m);
      var o = sel._mxOpts;
      /* v6.4 round 2: a collection quick-add (the sheet with a Buy now option) opens the bag drawer with its loading line on the
         tap; the add starts after the sheet's close animation and fills it (assets/myntelo-commerce.js). If no add follows in
         2.5 s the drawer closes again. */
      if (!buy && o && typeof o.onBuy === 'function') { var bag = D.querySelector('cart-notification'); if (bag && typeof bag.pending === 'function') { try { bag.pending(2500); } catch (e) {} } }
      close(function () { if (buy && o && typeof o.onBuy === 'function') o.onBuy(m); else sel._mxOnPick(m); });
      return;
    }
    tag('model_chosen', m);
    if (sel.value !== m) {
      sel.value = m;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      /* the 3D stage boots from data-model when it is not live yet (same as assets/myntelo-device.js setSelect) */
      var scope = sel.closest('.product, section') || D;
      scope.querySelectorAll('[data-m3d]').forEach(function (r) { if (r._m3dSetModel) r._m3dSetModel(m); else if (!r.dataset.m3dReady && !r.dataset.glb) r.dataset.model = m; });
      var k = kindOf(m);
      if (k) { try { localStorage.setItem(KEY, JSON.stringify({ brand: k, model: m, t: Date.now() })); } catch (e) {} }
      try { (W.dataLayer = W.dataLayer || []).push({ event: 'myntelo_device_pick', brand: k, model: m, how: 'sheet' }); } catch (e) {}
    }
    close(function () {
      var btn = gateButton(sel);
      if (btn) {
        btn.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        try { btn.focus({ preventScroll: true }); } catch (e) {}
      }
    });
  }

  /* transparent tap layer over the native select (phones) */
  function overlay() {
    var sel = modelSelect();
    if (!sel || sel._mxPick) return;
    sel._mxPick = 1;
    var box = sel.parentNode;
    var b = D.createElement('button');
    b.type = 'button';
    b.className = 'mx-pick';
    b.tabIndex = -1;
    b.setAttribute('aria-hidden', 'true');
    b.addEventListener('click', function (e) { e.preventDefault(); open(sel); });
    box.appendChild(b);
  }

  /* gate: never add while no model is chosen */
  function gated(el) { return el && el.closest && el.closest('[data-mx-choose]'); }
  function toPicker(btn) {
    var form = btn.form || btn.closest('form'), sel = null;
    if (form && form.id) sel = D.querySelector('select[form="' + form.id + '"]');
    if (sel && sel.options.length < 2) sel = null;
    sel = sel || modelSelect();
    if (mq.matches && sel && open(sel)) return;
    var spot = sel && (sel.closest('.product-form__input') || sel);
    if (!spot) return;
    spot.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    setTimeout(function () { try { sel.focus({ preventScroll: true }); } catch (e) { sel.focus(); } }, reduce ? 0 : 450);
  }
  W.addEventListener('click', function (e) {
    var b = gated(e.target);
    if (!b || b.tagName !== 'BUTTON' || b.type !== 'submit') return;
    e.preventDefault(); e.stopImmediatePropagation();
    toPicker(b);
  }, true);
  W.addEventListener('submit', function (e) {
    var f = e.target, b = f && f.querySelector && f.querySelector('[type="submit"][data-mx-choose]');
    if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    toPicker(b);
  }, true);

  /* v6.2: a detached <select> stands in for the page's Model select (empty first option, so nothing is pre-ticked unless asked) */
  function pick(models, current, onPick, opts) {
    if (!models || !models.length || typeof onPick !== 'function') return false;
    var s = D.createElement('select');
    s.add(new Option('', ''));
    models.forEach(function (m) { s.add(new Option(m, m)); });
    s.value = models.indexOf(current) >= 0 ? current : '';
    s._mxOnPick = onPick;
    s._mxOpts = opts || null;
    return open(s);
  }
  W.MynteloPicker = { open: function () { return mq.matches ? open() : false; }, select: modelSelect, pick: pick };

  function init() { if (mq.matches) overlay(); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
  if (mq.addEventListener) mq.addEventListener('change', init);

  /* v6.3 round 4: the bag drawer's express-pay row (sections/myntelo-cart-drawer.liquid, above Checkout) keeps one height while
     Shopify's wallet buttons load (they first draw a placeholder for every wallet the shop has, then drop the ones this browser
     can't use), so the drawer foot does not jump after an add. Height: this device's last settled one, else an estimate from the
     wallets listed for this page (Apple Pay only where the browser has it): 54px buttons, 12px apart (186px for three). Once the
     buttons stop changing for 1.5 s the row keeps at least that height, grows if the buttons need more, and remembers it. */
  var XKEY = 'myntelo:xpay-h', RKEY = 'myntelo:xpay-row';
  function holdExpress(box) {
    if (!box || box._mxh) return;
    /* v6.4 (2026-10-27): the wallets are Shopify's horizontal cart layout (not --vertical): one row of 44 px pills when they fit
       (3 wallets from ~330 px wide), a stack when they don't (iPhone Safari's 4 wallets: 200 px). Shopify first draws a 208 px
       placeholder stack, then the real buttons. The block holds one height from the start: this device's settled height for the
       same wallet count and width, else the prediction (row if each button gets >= 101 px), so nothing moves after it appears. */
    if (!box.classList.contains('additional-checkout-buttons--vertical')) {
      var bw = Math.round(box.getBoundingClientRect().width), nw = 0;
      /* round 2: Apple Pay counts only where the browser can actually pay with it (ApplePaySession.canMakePayments(), the same
         check Shopify's button makes); a bare ApplePaySession (no card set up, some in-app browsers) shows no Apple Pay button */
      var applePay = false; try { applePay = !!(W.ApplePaySession && W.ApplePaySession.canMakePayments && W.ApplePaySession.canMakePayments()); } catch (e) {}
      try { nw = JSON.parse(box.querySelector('shopify-accelerated-checkout-cart').getAttribute('wallet-configs')).filter(function (w) { return w.name !== 'apple_pay' || applePay; }).length; } catch (e) {}
      if (!bw || !nw) return; /* hidden drawer (width 0): measured again when it opens */
      box._mxh = 1;
      var rk = RKEY + ':' + nw + ':' + bw, hh = 0;
      try { hh = +localStorage.getItem(rk) || 0; } catch (e) {}
      if (!(hh >= 40 && hh < 400)) hh = (bw - (nw - 1) * 10) / nw >= 101 ? 44 : nw * 44 + (nw - 1) * 8;
      box.style.setProperty('--mx-xh', hh + 'px');
      box.style.minHeight = hh + 'px';
      /* round 3: tell the foot the wallets stack (more than one row), for the short-screen layout in myntelo-commerce.css */
      var foot = box.closest('.m-drawer__foot'), stack = function (x) { if (foot) foot.classList.toggle('mx-xstack', x > 100); };
      stack(hh);
      var row = box.firstElementChild, rt = 0;
      /* round 2: once Shopify's real buttons are in and their height has held for 400 ms, the reserve becomes exactly that height
         (shrinks a wrong guess instead of leaving a gap) and is remembered for this device */
      var rendered = function () { return !!box.querySelector('shop-pay-wallet-button, shopify-apple-pay-button, shopify-google-pay-button, shopify-paypal-button, shopify-venmo-button, shopify-amazon-pay-button'); };
      var seen = function () {
        if (!rendered()) return;
        var fh = Math.round((row || box).getBoundingClientRect().height);
        if (!(fh >= 40 && fh < 400)) return;
        box.style.minHeight = fh + 'px'; box.style.setProperty('--mx-xh', fh + 'px'); stack(fh);
        try { localStorage.setItem(rk, String(fh)); } catch (e) {}
      };
      if (row && W.ResizeObserver) new ResizeObserver(function () { clearTimeout(rt); rt = setTimeout(seen, 400); }).observe(row);
      else setTimeout(seen, 3000);
      if (W.MutationObserver && row) new MutationObserver(function () { clearTimeout(rt); rt = setTimeout(seen, 400); }).observe(row, { childList: true, subtree: true });
      return;
    }
    box._mxh = 1;
    var h = 0; try { h = +localStorage.getItem(XKEY) || 0; } catch (e) {}
    if (!h) {
      var el = box.querySelector('shopify-accelerated-checkout-cart'), n = 0;
      try { n = JSON.parse(el.getAttribute('wallet-configs')).filter(function (w) { return w.name !== 'apple_pay' || W.ApplePaySession; }).length; } catch (e) {}
      if (n) h = n * 54 + (n - 1) * 12;
    }
    if (!h) return;
    box.style.height = h + 'px'; box.style.overflow = 'hidden';
    var inner = box.firstElementChild, settle = 0;
    function done() {
      /* never shrinks under the held height (a few px of difference between renders would otherwise move the foot) */
      box.style.minHeight = h + 'px'; box.style.height = ''; box.style.overflow = '';
      var f = Math.round(box.getBoundingClientRect().height);
      if (f >= 40) { try { localStorage.setItem(XKEY, String(f)); } catch (e) {} }
    }
    if (inner && W.ResizeObserver) new ResizeObserver(function () { clearTimeout(settle); settle = setTimeout(done, 1500); }).observe(inner);
    else setTimeout(done, 3000);
  }
  function watchDrawer() {
    var d = D.querySelector('cart-notification'); if (!d || d._mxx || !W.MutationObserver) return; d._mxx = 1;
    [].forEach.call(d.querySelectorAll('.m-drawer__express'), holdExpress);
    new MutationObserver(function () { [].forEach.call(d.querySelectorAll('.m-drawer__express'), holdExpress); }).observe(d, { childList: true, subtree: true });
    new MutationObserver(function () { [].forEach.call(d.querySelectorAll('.m-drawer__express'), holdExpress); }).observe(d, { attributes: true, attributeFilter: ['hidden', 'class'] });
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', watchDrawer); else watchDrawer();
})();
